import { render, staticRenderFns } from "./AdminSelector.vue?vue&type=template&id=1ef885c1&scoped=true&"
import script from "./AdminSelector.vue?vue&type=script&lang=ts&"
export * from "./AdminSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSelector.vue?vue&type=style&index=0&id=1ef885c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef885c1",
  null
  
)

export default component.exports